<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="挑战赛" prop="challengeId" >
        <a-select v-model="form.challengeId" placeholder="请选择挑战赛">
          <a-select-option v-for="item in challengeList" :value="item.id" :key='item.id'>{{item.name}}</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="奖励类型" prop="awardType" >
        <a-radio-group v-model="form.awardType">
          <a-radio :value="1">现金</a-radio>
          <a-radio :value="2">现金券</a-radio>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item label="奖励额度" prop="rewardAmount" >
        <a-input v-model="form.rewardAmount" placeholder="请输入奖励额度" />
      </a-form-model-item>
      <a-form-model-item label="数量" prop="quantity" >
        <a-input v-model="form.quantity" placeholder="请输入数量" />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getAward, addAward, updateAward } from '@/api/award/award'
import {listChallenge} from "@/api/challenge/challenge";

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      challengeList:[],
      // 表单参数
      form: {
        id: null,

        challengeId: null,

        awardType: null,

        rewardAmount: null,

        quantity: null,

        objId: null,

        createTime: null,

        remark: null,

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        challengeId: [
          { required: true, message: '挑战赛不能为空', trigger: 'blur' }
        ],
        awardType: [
          { required: true, message: '奖励类型不能为空', trigger: 'change' }
        ],
        rewardAmount: [
          { required: true, message: '奖励额度不能为空', trigger: 'blur' }
        ],
        quantity: [
          { required: true, message: '数量不能为空', trigger: 'blur' }
        ],
      }
    }
  },
  filters: {
  },
  created () {
    this.initChallenge()
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
      this.reset()
    },
    initChallenge(){
      listChallenge({isDeleted:0}).then(res=>{
        this.challengeList = res.data
      })
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        challengeId: null,
        awardType: null,
        rewardAmount: null,
        quantity: null,
        objId: null,
        createTime: null,
        remark: null,
      }
      this.$nextTick(() => {
        if(this.$refs.form){
          this.$refs.form.resetFields()
        }
      })
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.open = true
      this.formType = 2
      const id = row ? row.id : ids
      getAward({"id":id}).then(response => {
        this.form = response.data

        this.formTitle = '修改'
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateAward(this.form).then(response => {
              this.$message.success(
                '修改成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addAward(this.form).then(response => {
              this.$message.success(
                '新增成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
